export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          欢迎提供宝贵意见或内容合作咨询
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">内容投稿</h3>
                <p className="text-xs text-foreground-500">content@mogumovie.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">问题反馈</h3>
                <p className="text-xs text-foreground-500">support@mogumovie.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-team-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">biz@mogumovie.com</p>
              </div>
            </div>

            <div className="border-t border-background-200/60 pt-6">
              <p className="text-xs text-foreground-400 text-center leading-relaxed">
                我们重视每一位观众的反馈与建议。如有任何关于观影体验、内容推荐或版权方面的问题，欢迎通过以上方式与我们取得联系。我们的团队通常会在48小时内回复您的邮件。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}